import React from "react";

export interface ChordTypographicFieldProps {
  label: string;
  value: string;
  onClick?: () => void;
  title?: string;
}

export const ChordTypographicField: React.FC<ChordTypographicFieldProps> = ({
  label,
  value,
  onClick,
  title,
}) => (
  <div className="flex flex-col gap-1.5 shrink-0" title={title}>
    <span className="text-[10px] font-sans uppercase tracking-widest text-white/30">
      {label}
    </span>
    <button
      type="button"
      onClick={onClick}
      className="text-left font-serif text-2xl text-white/70 hover:text-white transition-colors cursor-pointer leading-none"
    >
      {value}
    </button>
  </div>
);
